export default "__VITE_ASSET__4tdRex$K__"